import React from 'react';
import './App.css';
import { HelmetProvider } from 'react-helmet-async';
import { OpenProvider } from './context/api';
import Footer from './footer';
import ContactFab from './common/ContactFab';
import LogOutRoutes from './routes/LogoutRoutes';
import LoginRoutes from './routes/LoginRoutes';

function App() {
  return (
    <HelmetProvider>
      <OpenProvider>
        {false ? <LoginRoutes /> : <LogOutRoutes />}
        {false ? <></> : <Footer />}
        <ContactFab />
      </OpenProvider>
    </HelmetProvider>
  );
}

export default App;

